// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__F2B2u","search":"Settings_search__3vypn","filter":"Settings_filter__2x2ki"};